export interface PrivilegeUpdate {
    name: string;
    privilege: string;
}
